import { render, staticRenderFns } from "./ClientDetailModal.vue?vue&type=template&id=3fc9f54a&scoped=true&"
import script from "./ClientDetailModal.vue?vue&type=script&lang=js&"
export * from "./ClientDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailModal.vue?vue&type=style&index=0&id=3fc9f54a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc9f54a",
  null
  
)

export default component.exports